import { render, staticRenderFns } from "./ManagementAgilizaEvTable.vue?vue&type=template&id=2ec545c8"
import script from "./ManagementAgilizaEvTable.vue?vue&type=script&lang=js"
export * from "./ManagementAgilizaEvTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports